export default __webpack_public_path__ + "static/media/AIR EXPLOSION SIMULATOR.37438903.jpg";